import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsTransformationApi,
  IAboutUsTransformationApiRequest,
  IAboutUsTransformationApiGetAttrs,
  IAboutUsTransformationApiGetResponse,
  IAboutUsTransformationApiSaveAttrs,
  IAboutUsTransformationApiSaveResponse,
  IAboutUsTransformationApiGetAllAttrs,
  IAboutUsTransformationApiGetAllResponse,
} from 'interfaces/back-office/content-management/about-us/transformation/about-us-transformation-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsTransformationApi extends BaseApi<IAboutUsTransformationApi> implements IAboutUsTransformationApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_TRANSFORMATION_URL
  private aboutUsTransformationUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get branches
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsTransformationApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsTransformationApiGetAllResponse>} Promise<IAboutUsTransformationApiGetAllResponse>
   */
  async aboutUsTransformation_getAboutUsTransformations(
    payload: IAboutUsTransformationApiGetAllAttrs,
  ): Promise<IAboutUsTransformationApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsTransformationUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsTransformationApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsTransformationApiGetResponse>} Promise<IAboutUsTransformationApiGetResponse>
   */
  async aboutUsTransformation_getAboutUsTransformation(
    payload: IAboutUsTransformationApiGetAttrs,
  ): Promise<IAboutUsTransformationApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsTransformationUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsTransformationApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsTransformationApiSaveResponse>} Promise<IAboutUsTransformationApiSaveResponse>
   */
  async aboutUsTransformation_saveAboutUsTransformation(
    payload: IAboutUsTransformationApiSaveAttrs,
  ): Promise<IAboutUsTransformationApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.aboutUsTransformationUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
